import React from "react";

const variants = {
  default:
    "bg-primary text-primary-foreground shadow hover:bg-primary/90",

  destructive:
    "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90",

  outline:
    "border border-input bg-background shadow-sm hover:bg-accent hover:text-accent-foreground",

  secondary:
    "bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80",

  ghost:
    "hover:bg-accent hover:text-accent-foreground",

  link:
    "text-primary underline-offset-4 hover:underline",

  gold:
    "bg-gradient-gold text-gold-foreground font-semibold tracking-wide shadow-gold hover:brightness-110 transition-all",

  outlineGold:
    "border border-gold/50 text-gold hover:bg-gold hover:text-gold-foreground transition-all",
};

const sizes = {
  default: "h-9 px-4 py-2",
  sm: "h-8 rounded-md px-3 text-xs",
  lg: "h-11 rounded-md px-8 text-base",
  xl: "h-14 rounded-md px-10 text-xl",
  icon: "h-9 w-9",
};

const Button = ({
  children,
  className = "",
  variant = "default",
  size = "default",
  ...props
}) => {
  return (
    <button
      className={`
        inline-flex items-center justify-center gap-2 whitespace-nowrap
        rounded-md text-sm font-medium cursor-pointer
        transition-colors
        focus-visible:outline-none
        disabled:pointer-events-none
        disabled:opacity-50
        disabled:cursor-not-allowed
        ${variants[variant]}
        ${sizes[size]}
        ${className}
      `}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;